import { Configuration, PublicClientApplication } from '@azure/msal-browser';

const clientId = process.env.REACT_APP_ENTRA_CLIENT_ID;
const tenantId = process.env.REACT_APP_ENTRA_TENANT_ID;
const apiScope = process.env.REACT_APP_ENTRA_API_SCOPE;

export const isMicrosoftSignInConfigured = !!(clientId && tenantId && apiScope);

export const msalConfig: Configuration = {
  auth: {
    clientId: clientId || '',
    authority: `https://login.microsoftonline.com/${tenantId || 'common'}`,
    redirectUri: `${window.location.origin}/redirect`,
  },
  cache: {
    cacheLocation: 'localStorage',
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);

export const flowApiTokenRequest = {
  scopes: [apiScope || ''],
};
